module.exports = __webpack_public_path__ + "static/media/dashboard.82b1906b.svg";